import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative">
      <div className="grid-bg absolute inset-0 opacity-30 pointer-events-none" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative text-center max-w-lg"
      >
        <div className="label-mono text-[color:var(--accent)] mb-4">// error_404</div>
        <h1 className="font-display text-7xl md:text-9xl">
          404<span className="text-[color:var(--accent)]">.</span>
        </h1>
        <p className="mt-4 text-[color:var(--text-muted)] font-body">
          This page took a wrong turn. Let&apos;s get you home.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[color:var(--accent)] text-white font-mono text-sm"
        >
          ← Back to home
        </Link>
      </motion.div>
    </div>
  );
}
